import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import Feature from './Feature'
import Dropdown from './Dropdown'
import commonStyles from './styles/DropdownCommon.css'
import classNames from 'classnames'
import styles from './styles/FeatureDropdown.css'
import { useSelector } from 'react-redux'
import useFeatureFlag from '../../hooks/useFeatureFlag'

export const MoreDropdown = ({ showDropdownTriangle = true }) => {
  const location = useLocation()
  const user = useSelector(({ ui }) => ui.user)
  const [open, setOpen] = useState(false)
  const { enabled: betaPatentsEnabled } = useFeatureFlag({ featureFlag: 'beta-patents', user })

  return (
    <Dropdown
      open={open}
      setOpen={setOpen}
      title='More'
      className={styles.dropdownContainer}
      showTriangle={showDropdownTriangle}
    >
      <div className={styles.grid}>
        <div className={commonStyles.dropdownGroup}>
          {betaPatentsEnabled && (
            <Feature
              to='/patents'
              img={`${CONFIG.assetsBaseURL}/images/icons/feature-patents.svg`}
              imgClass={styles.illoCompact}
              header='Patents'
              onClick={() => {
                setOpen(false)
              }}
              className={classNames(styles.featureLink, {
                [styles.disabled]: location.pathname.includes('/patents')
              })}
              underline={false}
            >
              Search and explore worldwide patents.
            </Feature>
          )}
          <Feature
            to={user ? '/users/me/dashboards' : '/create-dashboard'}
            img={`${CONFIG.assetsBaseURL}/images/icons/feature-dashboards.svg`}
            imgClass={styles.illoCompact}
            header='Custom Dashboards'
            onClick={() => {
              setOpen(false)
            }}
            className={classNames(styles.featureLink, {
              [styles.disabled]: location.pathname.includes('/dashboards')
            })}
            underline={false}
          >
            Track research trends and uncover insights from selected groups of papers.
          </Feature>
          <Feature
            to='/journals'
            img={`${CONFIG.assetsBaseURL}/images/icons/feature-journals.svg`}
            imgClass={styles.illoCompact}
            header='Journals'
            onClick={() => {
              setOpen(false)
            }}
            className={classNames(styles.featureLink, {
              [styles.disabled]: location.pathname.includes('/journals')
            })}
            underline={false}
          >
            Explore academic journals and analyze their citation patterns and metrics.
          </Feature>
          <Feature
            to='/affiliations'
            img={`${CONFIG.assetsBaseURL}/images/icons/organization_icon.svg`}
            imgClass={styles.illoReg}
            header='Organizations'
            onClick={() => {
              setOpen(false)
            }}
            className={classNames(styles.featureLink, {
              [styles.disabled]: location.pathname.includes('/affiliations')
            })}
            underline={false}
          >
            Discover research from universities, institutions, and organizations.
          </Feature>
          <Feature
            to='/institutions'
            img={`${CONFIG.assetsBaseURL}/images/icons/referrals.svg`}
            imgClass={styles.illoCompact}
            header='Funders'
            onClick={() => {
              setOpen(false)
            }}
            className={classNames(styles.featureLink, {
              [styles.disabled]: location.pathname.includes('/institutions')
            })}
            underline={false}
          >
            Find funding agencies and explore the research projects they support.
          </Feature>
        </div>

        <div className={commonStyles.dropdownGroup}>
          <Feature
            to='/extension-install'
            img={`${CONFIG.assetsBaseURL}/images/icons/browser_extension_icon.svg`}
            imgClass={styles.illoReg}
            header='Browser Extension'
            onClick={() => {
              setOpen(false)
            }}
            className={classNames(styles.featureLink, {
              [styles.disabled]: location.pathname.includes('/extension-install')
            })}
            underline={false}
          >
            Use Scite insights anywhere you read research across the web.
          </Feature>
          <Feature
            href='https://api.scite.ai/docs'
            img={`${CONFIG.assetsBaseURL}/images/icons/smart_cite_icons.svg`}
            imgClass={styles.illoCompact}
            header='Scite API'
            onClick={() => {
              setOpen(false)
            }}
            className={styles.featureLink}
            underline={false}
          >
            Integrate Scite citation data into your tools, applications, or workflows.
          </Feature>
          <Feature
            to='/request-a-demo'
            img={`${CONFIG.assetsBaseURL}/images/icons/request_demo.svg`}
            imgClass={styles.illoReg}
            header='Get a Demo'
            onClick={() => {
              setOpen(false)
            }}
            className={classNames(styles.featureLink, {
              [styles.disabled]: location.pathname.includes('/request-a-demo')
            })}
            underline={false}
          >
            See how Scite helps researchers and teams improve research outcomes.
          </Feature>
        </div>
      </div>
    </Dropdown>
  )
}

export default MoreDropdown
